import { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { WA_MSG, whatsappUrl } from '../lib/whatsapp.js';

const links = [
  { label: 'Produto', href: '#produto' },
  { label: 'Como funciona', href: '#como' },
  { label: 'Planos', href: '#planos' },
];

const contactHref = whatsappUrl(WA_MSG.general);

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={[
        'fixed inset-x-0 top-0 z-50 transition-[background,border,backdrop-filter] duration-300',
        scrolled
          ? 'border-b border-white/10 bg-ink/80 backdrop-blur-xl'
          : 'border-b border-transparent bg-transparent',
      ].join(' ')}
    >
      <div className="mx-auto flex h-16 max-w-content items-center justify-between px-6 lg:px-8">
        <a href="#" className="font-display text-xl font-bold tracking-tight text-bone">
          H<span className="text-copper">barber</span>
        </a>

        <nav className="hidden items-center gap-10 md:flex" aria-label="Principal">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-medium text-mist transition-colors hover:text-bone"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-5 md:flex">
          <a href="/admin/" className="text-sm font-medium text-mist transition-colors hover:text-bone">
            Entrar
          </a>
          <a
            href={contactHref}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-md bg-copper px-4 py-2 text-sm font-semibold text-ink transition-colors hover:bg-copper-soft"
          >
            WhatsApp
          </a>
        </div>

        <button
          type="button"
          className="p-2 text-bone md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? 'Fechar menu' : 'Abrir menu'}
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-ink-soft px-6 py-5 md:hidden">
          <ul className="flex flex-col gap-4">
            {links.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="block text-base font-medium text-bone"
                  onClick={() => setOpen(false)}
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href={contactHref}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 block rounded-md bg-copper px-4 py-2.5 text-center text-sm font-semibold text-ink"
                onClick={() => setOpen(false)}
              >
                WhatsApp
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
